// pages/Home.js

import React from 'react';

function Home() {
  const name = localStorage.getItem('name') || localStorage.getItem('username') || '';
  return (
    <div className="p-4">
      <h2 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
        {name ? `Welcome, ${name}` : 'Welcome'}
      </h2>
      <p className="mt-2 text-sm text-gray-600">Choose a screen from the menu to get started.</p>
    </div>
  );
}

export default Home;
